  // Confetti button Animation
let ConfettiAnimation = function(target,count){
  const removeBtn = $(target);
  const parent = $('.left-bottom');
    function random(max){
      return Math.random() * (max - 0) + 0;
    }

    var c = document.createDocumentFragment();
    for (var i=0; i<100; i++) {
      var styles = 'transform: translate3d(' + (random(500) - 250) + 'px, ' + (random(200) - 150) + 'px, 0) rotate(' + random(360) + 'deg);\
background: hsla('+random(360)+',100%,50%,1);\
animation: bang 700ms ease-out forwards;\
opacity: 0';

//       console.log(styles)
      var e = document.createElement("i");
      e.style.cssText = styles.toString();
      c.appendChild(e);
//       console.log(e)
    }
    // document.body.appendChild(c);
    
    removeBtn.append(c);
    if(count==1){
      $('img.empty-box',removeBtn).addClass('hide');
      $('img.full-box',removeBtn).removeClass('hide');
      parent.addClass('box-is-full');
    }
    setTimeout(function(){
      $('i',removeBtn).remove();
    }, 1000);
    
//     console.log(c)
}

  
$(document).ready(function() {
  var box_productHTML = `<div class="box-items--item" data-id="{id}" data-index="{index}" data-title="{image_alt}">
<img  src="{image_src}" data-index="{index}" alt="{image_alt}">
</div>`;
  var box_summaryItem =  `<div class="{item-type}">
<div class="product">
<img src="{item-bagImage}" alt="{item-displayName}"><span title="{item-displayName}" class="item_title">{item-displayName}&nbsp;:&nbsp;</span> <span class="item_qty" title="{item-count}">{item-count}</span>
</div>
</div>`;

  // *&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^
  // *&^*&^*&^*&^*      SETUP         *&^*&^*&^*&^*&^*&^*&^
  // *&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^

  // var box to associate it with the main obj
  // will be set after the main box obj has been created
  var _box;
  var $el = $('#box'),
      priceDisplay = $('.price--counter .price'),
      variantDisplay = $('.price--counter .variant'),
      counterDisplay = $('.price--counter .counter'),
      $clear = $el.find('.clear'),
      $items = $el.find('.picker-grid'),
      $form = $el.find('.box-form'),
      $submit = $el.find('.add-box-to-cart'),
      $addons = $el.find('.addons'),
      key = setupKey(),
      boxId = $('.main-box-product-id').val(),
      recharge = false,
      size="14ct",
      moneySpan=$('#money-price'),
      priceSm = "$45.78",
      priceLg = "$91.56";
  priceSm_rc = "$45.78"
  priceLg_rc = "$91.56"
  priceSm_rc_sub = "$43.49"
  priceLg_rc_sub = "$86.98"
  _box = Theme.view.box;
  var dt = Date.now();
  var bundle_type = "bundle-group-"+theme.current_page+":"+theme.date_time_now;

  var current_box = getCurrentBox($el.attr('data-active-bundle'));
  if(current_box.length>0){
    Theme.view.box = {
      productsForBox: current_box,
      pouchesAdded: [],
      itemsInBox: [],
      count: 0,
      capacity: (parseInt($('button.selected').attr('data-capacity'))),
      full: false,
      price: (parseInt($('button.selected').attr('data-variant-price'))/100).toFixed(2)
    };
    _box = Theme.view.box;
    console.log(_box)
    $('[data-box-capacity]').text((parseInt($('button.selected').attr('data-capacity'))));
    $('[data-box-count]').text(Theme.view.box.count)
  }
  $submit.on('click', onSubmit);

  $('body').on('click','.bundle-remove a',function(e){
    e.preventDefault();
    var ids = $(this).attr('data-ids');
    removeItems(ids);
  })


  $('button[data-variant-price]').on('click',function(e){
    $('.size-select button').removeClass('selected');
    if (!$(this).hasClass('selected')) {
      $(this).addClass('selected');
    }
    var price = parseInt($(this).attr('data-variant-price')),
        varTitle = $(this).attr('data-variant-title'),
        capacity= parseInt($(this).attr('data-capacity')),
        wasbundle_price = parseInt($(this).attr('data-variant-wasbundle_price')),
        bundle=$(this).attr('data-bundle');
    console.log('price',price)
     $('[data-total-price]').html(`<span>From </span>`+theme.Currency.formatMoney(price, theme.settings.moneyFormat));
    $('[data-total-wasprice]').html(theme.Currency.formatMoney(wasbundle_price, theme.settings.moneyFormat));
    $('[data-current-variant-title]').text("("+varTitle+")");
    $("#box").attr('data-box-size',capacity)
    $('.select-grid').addClass('hide');
    $el.attr('data-active-bundle',bundle)
    $('.select-grid[data-bundle="'+bundle+'"]').removeClass('hide');
	
    var current_box = getCurrentBox(bundle);
    if(current_box.length>0){
      Theme.view.box = {
        productsForBox: current_box,
        pouchesAdded: [],
        itemsInBox: [],
        count: 0,
        capacity: capacity,
        full: false,
        price: (price/100).toFixed(2)
      };
      _box = Theme.view.box;
    }
  })
  
  // Add/remove pouches
  $('.select-grid .available').on('click', '.remove,.add', function (e) {
//     console.log('ere')
    e.preventDefault();

    var opContainer = $(this).parent();
    var itemCount = parseInt($('.count', opContainer).text());
    var boxSize = $($el).attr('data-box-size');
    var totalCount = Theme.view.box.count;
    var boxCapacity = Theme.view.box.capacity;
    var op = $(this).hasClass('add') ? 'add' : 'remove';
    // Nothing to remove
    if (op === 'remove' && itemCount === 0) {
      return;
    }

    // Box is full
    if (op === 'add' && totalCount === boxCapacity) {
      return;
    }
    var oneLeft = (Theme.view.box.capacity-Theme.view.box.count)
//     console.log(boxCapacity,itemCount)
    if(op === 'add' && oneLeft==1 && totalCount != boxCapacity){
      ConfettiAnimation('.js-confetti-trigger',oneLeft);
    }
    // Add
//     console.log(boxCapacity)
    if (op === 'add') {
      $('.count', opContainer).text(itemCount + 1);
      var newTotal = totalCount + 1;
      Theme.view.box.count = newTotal;
//       console.log("Theme.view.box.count: ",Theme.view.box.count)
      addItem($(opContainer).data('product-id'));
      Box_item_counter();
      return;
    }
    // Remove
    if (op === 'remove') {
      $('.count', opContainer).text(itemCount - 1);
      if(totalCount>0) Theme.view.box.count = totalCount - 1;
      removeItem($(opContainer).data('product-id'));
      Box_item_counter();
    }
   

    if (op === 'remove' && totalCount <= boxCapacity) {
      $('img.empty-box').removeClass('hide');
      $('img.full-box').addClass('hide');
      $('.left-bottom').removeClass('box-is-full');
    }
  });

  // Navigation between screens
  $('.status-bar').on('click', '.action', function (e) {
    e.preventDefault();
// console.log(_box)
    var currentScene = $($el).attr('data-current-scene');
    var sceneID = currentScene.split('-')[1];
    var action = $(this).data('action'),
        capacity = $("#box").attr('data-box-size');

    switch (action) {
      case 'next':
        if (sceneID == 1 || (sceneID == 2 && _box.capacity === _box.count)) {
          $('[data-summary-items]').empty();
          var newSceneId = parseInt(sceneID) + 1;
          $($el).attr('data-current-scene', 'scene-' + newSceneId);
          var bundle = $($el).attr('data-active-bundle');
          getCurrentBox(bundle);
          $('[data-box-capacity]').text(capacity);
          $('[data-box-count]').text(Theme.view.box.count)
          if(newSceneId==3){
            prepare_summary();
          }
        }
        window.scrollTo(0,0);
        break;
      case 'back':
        var newSceneId = parseInt(sceneID) - 1;
        if(newSceneId==1){
          $('[data-box-count]').text(Theme.view.box.count);
          $('.box-items-container').empty();
        }
        $($el).attr('data-current-scene', 'scene-' + newSceneId);
//         Theme.view.box.count = 0;
//         console.log(Theme.view.box)
        
        break;
      case 'cart':
        if (!$(this).hasClass('disabled')) {
          $(this).addClass('disabled');
          addProductsToCart();
        }
        break;
    }

  });
  
  // *&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^
  // *&^*&^*&^*&^*      METHODS       *&^*&^*&^*&^*&^*&^*&^
  // *&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^*&^

  function getCurrentBox(bundle){
    let current_box = $.grep(Theme.view.boxes.productsAdded,function(res){return res.bundle_name==bundle});
    return current_box;
  }
  
  
  function removeItems(items) {
//     console.log(items)
    var itemsProcessed = items;
//     console.log(itemsProcessed)
    var itemsArray = itemsProcessed.split(',');
    var qty = 0;
    var data = { updates: {} };

    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
//         console.log(res)
        window.location.reload();
      }
    });

  }
  function Box_item_counter(){
    if(Theme.view.box.count <= Theme.view.box.capacity){
      $('[data-box-count]').text(Theme.view.box.count)
    }
    else{
      $('[data-box-count]').text(0)
    }
  }

  function prepare_summary(){
    $('[data-summary-items]').empty();
    for(var i = 0; i < Theme.view.box.itemsInBox.length; i++) {
      var prod_item = Theme.view.box.itemsInBox[i];
      var str = box_summaryItem;
      str = str.replaceAll('{item-type}',prod_item.type).replaceAll('{item-bagImage}',prod_item.bagImage).replaceAll('{item-displayName}',prod_item.displayName).replaceAll('{item-count}',prod_item.count);
      var ele = $(str);
      $('[data-summary-items]').append(ele);
    }
  }

  // when a pouch is clicked on from the front-end,
  // add it to the box object as itemInBox
  function addItem(id) {

//     console.log(id,_box)
    var product = _box.productsForBox.find(function(product) {
      return product.id == id;
    });
    var item = {
      product: product.product,
      bagImage: product.image,
      displayName: product.displayName.trim(),
      count: 1,
      bundle_title:product.bundle_title,
      bundle_image:product.bundle_image,
      type: bundle_type,
      properties: {
        _box_key: key
      }
    };

    _box.pouchesAdded.push(item);

    var prod = box_productHTML;
//     console.log(item.type)
    prod = prod.replaceAll('{id}',product.id).replaceAll('{image_src}',product.image).replaceAll('{index}',_box.count).replaceAll('{image_alt}',product.displayName);
    $('.box-items-container').append($(prod));

    // find and return the current existing object in the box
    // if undefined, then that pouch isn't in the box, so add a new line item
    function currentItem(currentItem) {
      if(currentItem.displayName == product.displayName) {
        return currentItem.product['handle'] === product.product['handle'];
      }
    }

    var pouchInBox = _box.itemsInBox.find(currentItem);

    // if the product is in the box, update the count
    if(pouchInBox) {
      pouchInBox.count = pouchInBox.count + 1;
//       console.log(pouchInBox.count)
    } else {
      _box.itemsInBox.push(item);
    }
    
    

  }

  function removeItem(id) {

    var trimmed = false;
    
    var newPouches = _box.pouchesAdded.reduce(function (acc, pouch) {
      if (trimmed || pouch.product.id != id) {
        acc.push(pouch);
      }
      if (pouch.product.id == id) {
        trimmed = true;
      }
      return acc;
    }, []);

    _box.pouchesAdded = newPouches;


    var pouchInBox = _box.itemsInBox.find(function (item) {
      return item.product.id == id;
    });

    // if the product is in the box, update the count
    if(pouchInBox){
      if(pouchInBox.count > 1) {
        pouchInBox.count = pouchInBox.count - 1;
      }
      else {
        _box.itemsInBox = _box.itemsInBox.filter(function (item) {
          return item.product.id != id;
        })
      }

      var ele_to_remove = $('.box-items--item[data-id='+id+']:last'),
          ele_need_to_update =$('.box-items--item[data-id='+id+']:last').nextAll() ;
      ele_to_remove.remove();
      var counter = parseInt(ele_to_remove.attr('data-index'));
//       console.log(counter)
      if(counter>0){
        for(var i = 0; i < ele_need_to_update.length; i++) {
          $(ele_need_to_update[i]).attr('data-index',counter);
          $(ele_need_to_update[i]).find('img').attr('data-index',counter);
          counter++;
        }
      }
    }
  }


  // if and when the box is full of pouches, the
  // add to cart button will become clickable. This
  // submits the form and processes all the items in the box
  function onSubmit(e) {

    e.preventDefault;

    // if the button is disabled, get out of here
    if($(this).hasClass('disabled')) return;

    // disable the button (to prevent hammering on it)
    disableBtn();

    // determine size and if recharge is set
    if($('input[name=purchase_type]:checked').val() == 'autodeliver') {
      recharge = true;
    }
    if (size == "28ct") {
      boxId = $('.big-box-product-id').val();
    }


    // add everything to cart
    addProductsToCart();
  }

  // this function assumes recharge is set to true
  // and goes through each item in _box.itemsInBox
  // and adds recharge interval properties to the item
  // this should force things into recharge's checkout/system
  function addRechargeProperties() {

    var rc_id = $('#rc_subscription_id').val(),
        rc_type = $('#rc_shipping_interval_unit_type').val(),
        rc_frequency = $('.rc_select.rc_select__frequency').val();


    for(var i = 0; i < _box.itemsInBox.length; i++) {

      var cur = _box.itemsInBox[i];

      if(cur.type != 'addon') {
        cur.properties['subscription_id'] = rc_id;
        cur.properties['shipping_interval_unit_type'] = rc_type;
        cur.properties['shipping_interval_frequency'] = rc_frequency;
      }

    }

  }

  // this runs through everything and
  // adds it to cart sequentially
  function addProductsToCart() {

    var product_data = _box.itemsInBox.map(function(product) {
      //       console.log(product)
      return {quantity:product.count,id:product.product.variants[0].id,properties:{"_bundle_type":product.type,"_bundle_title":product.bundle_title,"_bundle_image":product.bundle_image}};
    });
    //     # add the items to the data object we need to pass to the fetch call 
    $('button[data-action="cart"]').text('Adding...')
    var formData = {
      items: product_data
    }
    var requests = fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => response.json())
    .then(function(data) {
      console.log(data);
    }).catch(function (error) {
      console.warn(error);
      alert("Something went wrong, please try again.");
    }).finally(function () {
      console.log('finally')
      $('button[data-action="cart"]').text('Add to cart');
      window.location.href = '/cart';
    });

    var boxProduct = _box.itemsInBox.find(function(item) {
      return item.type == 'box';
    });

  }

  // function disableBtn() {
  //   $submit.addClass('disabled');
  //   $submit.addClass('loading');
  // }
  //
  // function enableBtn() {
  //   $submit.removeClass('disabled');
  //   $submit.removeClass('loading');
  // }

  // when any call to clear box is triggered, use
  // this function to reset the object, which
  // in turns resets the front-end
  // function clearBox(e) {
  //   $(".pouch-counter .item .current-count").text(0);
  //   _box.pouchesAdded = [];
  //   _box.itemsInBox = [];
  //   _box.full = false;
  // }

  function setupKey() {
    var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array(32).join().split(',').map(function() { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');
  }

  // // stick form
  // var $productForm = $('#product .box-form'),
  //         $stickyForm = $productForm.closest('.sticky-product-form'),
  //         scrollDelay;
  //
  // function stickForm() {
  //   var formBottom = $stickyForm.offset().top + $stickyForm.outerHeight(),
  //           formBeyond = $(window).scrollTop() > formBottom,
  //           isStuck = $stickyForm.attr('data-stuck') == 'true';
  //
  //   if (_box.full) {
  //     $productForm.removeClass("hidden");
  //   } else {
  //     $productForm.addClass("hidden");
  //   }
  //
  //   if (!isStuck && formBeyond) {
  //     $stickyForm.height($stickyForm.height());
  //     $productForm.css({position: 'absolute'});
  //   } else if (isStuck && !formBeyond) {
  //     $stickyForm.css({height: 'auto'});
  //     $productForm.css({position: 'static'});
  //   }
  //
  //   $stickyForm.attr('data-stuck', formBeyond);
  // }
  //
  // $(window).on('scroll', stickForm);
}); // /theme-ready